import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Import pages
import Login from "./pages/Login";
import SendFax from "./pages/SendFax";
import ReceivedFaxes from "./pages/ReceivedFaxes";
import SentFaxes from "./pages/SentFaxes";
import AdminUsers from "./pages/AdminUsers";

// Import layout components
import AppHeader from "./Layout/AppHeader";
import AppSidebar from "./Layout/AppSidebar";
// import AppFooter from "./Layout/AppFooter"; // Removed footer
// import ThemeOptions from "./Layout/ThemeOptions"; // Removed theme options

// Import theme context
import { connect } from "react-redux";
import { useResizeDetector } from "react-resize-detector";
import cx from "classnames";

const AppLayout = ({ children, ...props }) => {
  const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    enableClosedSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
  } = props;

  const { width, ref } = useResizeDetector();

  return (
    <div ref={ref}>
      <div
        className={cx(
          "app-container app-theme-" + colorScheme,
          { "fixed-header": enableFixedHeader },
          { "fixed-sidebar": enableFixedSidebar || width < 992 },
          { "fixed-footer": enableFixedFooter },
          { "closed-sidebar": enableClosedSidebar || width < 992 },
          {
            "closed-sidebar-mobile": width < 992,
          },
          { "sidebar-mobile-open": enableMobileMenu },
          { "body-tabs-shadow-btn": enablePageTabsAlt }
        )}
      >
        <AppHeader />
        <div className="app-main">
          <AppSidebar />
          <div className="app-main__outer">
            <div className="app-main__inner">{children}</div>
            {/* <AppFooter /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

const ConnectedAppLayout = connect((state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
}))(AppLayout);

const App = () => {
  return (
    <AuthProvider>
      {/* <ThemeOptions /> */}
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/fax/send"
          element={
            <ProtectedRoute>
              <ConnectedAppLayout>
                <SendFax />
              </ConnectedAppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/fax/received"
          element={
            <ProtectedRoute>
              <ConnectedAppLayout>
                <ReceivedFaxes />
              </ConnectedAppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/fax/sent"
          element={
            <ProtectedRoute>
              <ConnectedAppLayout>
                <SentFaxes />
              </ConnectedAppLayout>
            </ProtectedRoute>
          }
        />

        {/* Admin Routes */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute requireAdmin={true}>
              <ConnectedAppLayout>
                <AdminUsers />
              </ConnectedAppLayout>
            </ProtectedRoute>
          }
        />

        {/* Default redirects */}
        <Route path="/" element={<Navigate to="/fax/send" replace />} />
        <Route path="*" element={<Navigate to="/fax/send" replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
